var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m31 36a1 1 0 0 1 -.856-1.515l4.836-8.061-7.78 1.556a1 1 0 0 1 -1.053-1.5l6-10a1 1 0 0 1 1.714 1.03l-4.836 8.061 7.775-1.551a1 1 0 0 1 1.053 1.5l-6 10a1 1 0 0 1 -.853.48z",
    fill: "#5b6772",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.146 54.255a2.985 2.985 0 0 1 -4.292 0c-.6-.619-1.295-1.346-2.047-2.155-7.059.317-10.632 1.32-11.611 1.9 1.267.778 6.6 2 15.8 2s14.537-1.219 15.8-2c-.979-.583-4.552-1.586-11.611-1.9-.744.809-1.438 1.536-2.039 2.155z",
    fill: "#5b6772",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.71 52.86c4.06-4.17 17.29-18.46 17.29-26.86a18 18 0 0 0 -36 0c0 8.4 13.23 22.69 17.29 26.86a1.008 1.008 0 0 0 1.42 0zm-.71-40.86a14 14 0 1 1 -14 14 14.015 14.015 0 0 1 14-14z",
    fill: "#BC2555",
    "data-original": "#000000"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.b3c7467a326e23e6d41ea1cd3f45bbff.svg";
export { ForwardRef as ReactComponent };